import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getAllDiscount,
  addDiscount,
  updateDiscount,
  removeDiscount,
  updateDiscountDraft,
} from '@store/actions/discount.action'
import { Discount } from '@dataTypes/discount.type'

type DiscountState = {
  discounts: Discount[]
  count: number
  draftDiscounts: Discount[]
  loading: boolean
  error: string | null
}

const initialState: DiscountState = {
  discounts: [],
  count: 0,
  draftDiscounts: [],
  loading: false,
  error: null,
}

const discountSlice = createSlice({
  name: 'discount',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDiscount.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getAllDiscount.fulfilled,
        (
          state,
          action: PayloadAction<{ discounts: Discount[]; count: number }>,
        ) => {
          state.loading = false
          state.discounts = action.payload.discounts
          state.count = action.payload.count
          state.draftDiscounts = action.payload.discounts
        },
      )
      .addCase(getAllDiscount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      .addCase(
        addDiscount.fulfilled,
        (state, action: PayloadAction<Discount>) => {
          state.discounts.push(action.payload)
        },
      )
      .addCase(
        updateDiscount.fulfilled,
        (state, action: PayloadAction<Discount>) => {
          const index = state.discounts.findIndex(
            (item) => item.discount_id === action.payload.discount_id,
          )
          if (index !== -1) {
            state.discounts[index] = {
              ...state.discounts[index],
              ...action.payload,
            }
          }
        },
      )
      .addCase(
        removeDiscount.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.discounts = state.discounts.filter(
            (item) => item.discount_id !== action.payload,
          )
        },
      )
      .addCase(removeDiscount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(addDiscount.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addDiscount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(updateDiscount.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateDiscount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      .addCase(
        updateDiscountDraft,
        (state, action: PayloadAction<Discount[]>) => {
          state.draftDiscounts = action.payload
        },
      )
  },
})

export default discountSlice.reducer
